import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import Axios from 'axios'

import '~/assets/scss/pages/authentication.scss'
import EmailIcon from '~/assets/img/icons/email.svg'
import SuccessIcon from '~/assets/img/icons/success.svg'
import { AuthLayout } from './components/AuthLayout'
import { queries } from '~/constants/mediaQuery'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [resetCodeLoading, setResetCodeLoading] = useState(false)
  const [resetCodeSent, setResetCodeSent] = useState(false)
  const intl = useIntl()

  async function handleSubmit(e) {
    e.preventDefault()
    setResetCodeLoading(true)
    await Axios.post(`${process.env.REACT_APP_API_URL}/forgot-password`, {
      email,
    })
    setResetCodeLoading(false)
    setResetCodeSent(true)
  }

  return (
    <AuthLayout
      title="Reset password"
      description="Enter your email to start the password recovery. You will receive by email the instructions on how to access your account."
    >
      <ForgotPasswordDiv>
        {resetCodeSent ? (
          <div className="alert-div">
            <div className="alert-box">
              <div>
                <img src={SuccessIcon} alt="" />
              </div>
              <div>
                <FormattedMessage id="The instructions were sent to your e-mail, if it was registered in our database." />
              </div>
            </div>
            <a className="back-button" href="/login">
              <FormattedMessage id="Go back to login" />
            </a>
          </div>
        ) : (
          <>
            <div className="text-input">
              <div className="label-row">
                <label htmlFor="email">
                  <FormattedMessage id="Email" />
                </label>
              </div>
              <div className="input-row">
                <img src={EmailIcon} alt="" />
                <input
                  id="email"
                  autoComplete="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={resetCodeLoading}
                  placeholder={intl.formatMessage({ id: 'Enter your e-mail' })}
                />
              </div>
            </div>
            <div className="button-menu">
              <button
                className="proceed-button"
                data-loading={resetCodeLoading}
                disabled={!email.trim() || resetCodeLoading}
                onClick={handleSubmit}
              >
                <FormattedMessage id="Reset password" />
              </button>
              <a className="back-button" href="/login">
                <FormattedMessage id="Go back to login" />
              </a>
            </div>
          </>
        )}
      </ForgotPasswordDiv>
    </AuthLayout>
  )
}

const ForgotPasswordDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  .text-input {
    position: relative;
    display: flex;
    min-width: 30.5625rem;
    flex-direction: column;
    justify-content: center;
    gap: 0.75rem;

    @media (${queries.less.mds}) {
      min-width: 100%;
    }

    .label-row {
      label {
        font-weight: 700;
        color: #000;
        font-size: 1rem;
      }
    }

    .input-row {
      width: 100%;
      max-width: 30.5625rem;
      height: 3rem;

      input {
        height: 3rem;
        width: 100%;
        max-width: 30.5625rem;
        border: 1px solid #d8d8d8;
        border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
        padding: 0.5rem 1rem 0.5rem 3rem;

        &::placeholder {
          color: #cfcfcf;
        }

        @media (${queries.less.mds}) {
          max-width: 100%;
        }
      }

      img {
        position: absolute;
        left: 1rem;
        bottom: 4px;
        transform: translateY(-50%);
      }

      @media (${queries.less.mds}) {
        max-width: 100%;
      }
    }
  }

  .button-menu {
    min-width: 30.5625rem;
    max-width: 30.5625rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    @media (${queries.less.mds}) {
      min-width: 100%;
    }

    .proceed-button {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.75rem 1.5rem;
      border: none;
      border-radius: 0.25rem;
      background-color: #7367f0;
      color: #fff;
      font-size: 1.125rem;
      font-weight: 700;

      &:disabled {
        background-color: #b9b3f7;
        cursor: not-allowed;
      }

      &[data-loading='true'] {
        background-color: #b9b3f7;
        cursor: wait;
      }

      @media (${queries.less.mds}) {
        max-width: 100%;
      }
    }

    .back-button {
      color: #7367f0;
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.5rem;
    }
  }

  .alert-div {
    width: 100%;
    max-width: 30.5625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 2rem;

    @media (${queries.less.mds}) {
      min-width: 100%;
    }

    .alert-box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.75rem 1rem;
      border-radius: 0.375rem;
      gap: 0.75rem;

      border: 1px solid #9ae6b4;
      background: #f0fff4;
    }
  }
`

export default ForgotPassword
